import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const MatrixContainerStyled = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  height: 76vh;
  overflow-y: auto;
  margin-top: ${({ theme }) => theme.spacings[400]};
`;

export const TableStyled = styled.table`
  ${({ theme }) => css`
    width: 100%;
    border-right: solid 1px ${theme.colors.grey[300]};
  `}
`;

export const TableRowHeaderStyled = styled.tr`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[100]};
  `}
`;

export const TableHeaderStickyStyled = styled.th`
  ${({ theme }) => css`
    position: sticky;
    top: 0;
    left: 0;
    vertical-align: top;
    border-right: solid 1px ${theme.colors.grey[300]};
    z-index: 1;
    background-color: ${theme.colors.grey[100]};
  `}
`;

export const HeaderContainerStlyed = styled(Box)`
  height: 44px;
`;

export const HeaderStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
})`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes[300]};
    color: ${theme.colors.grey[1000]};
    white-space: nowrap;
    border-right: solid 1px ${theme.colors.grey[300]};
    border-bottom: solid 1px ${theme.colors.grey[300]};
    border-top: solid 1px ${theme.colors.grey[300]};
  `}
`;
